import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { LoginComponent } from "Components/Authentication/Login.component";
import { ForgotPasswordComponent } from "Components/Authentication/ForgotPassword.component";
import { SetNewPasswordComponent } from "Components/Authentication/SetNewPassword.component";
import { getNewPasswordChallenge } from "Slices/appState";

import { AuthenticationContainer, LoggedInNotify } from "./styles";

export const AuthenticationPage = () => {
  const [showLoggedInNotify, setShowLoggedInNotify] = useState(false);
  const newPasswordChallenge = useSelector(getNewPasswordChallenge);

  useEffect(() => {
    const handleNewJWT = (event: StorageEvent) => {
      if (event.key === "JWT" && event.oldValue === null && event.newValue) {
        setShowLoggedInNotify(true);
      }
    };
    window.addEventListener("storage", handleNewJWT);
    return () => {
      window.removeEventListener("storage", handleNewJWT);
    };
  }, []);

  const [authStage, setAuthStage] = useState("INIT");

  const handleCancel = () => {
    setAuthStage("INIT");
  };

  const handleForgotPass = () => {
    setAuthStage("FORGOT");
  };

  const authenticationContent = useMemo(() => {
    const isLoggedIn = Boolean(window.localStorage.getItem("JWT"));
    if (isLoggedIn) {
      return <Navigate to="/" replace={true} />;
    } else if (newPasswordChallenge) {
      return <SetNewPasswordComponent challenge={newPasswordChallenge} />;
    } else if (authStage === "INIT") {
      return <LoginComponent onForgotSelected={handleForgotPass} />;
    } else if (authStage === "FORGOT") {
      return <ForgotPasswordComponent onCancel={handleCancel} />;
    } else return null;
  }, [authStage, newPasswordChallenge]);

  return (
    <AuthenticationContainer>
      {showLoggedInNotify && (
        <LoggedInNotify>
          You signed in with another tab or window. Reload page to refresh your
          session
        </LoggedInNotify>
      )}
      {authenticationContent}
    </AuthenticationContainer>
  );
};
